import React, { Component } from 'react';
import { injectIntl } from 'react-intl'
import Flickity from 'react-flickity-component'
import Magnifier from 'react-magnifier'
import { Icon } from "antd"
import { PAGINATION_SIZE } from '../../utils'
import ClipLoader from 'react-spinners/BeatLoader'
import classNames from 'classnames/bind'
import "./pdf-view.css"

const imgCellPdfViewStyle = {
  "maxWidth": "100%",
  "maxHeight": "100%",
  "width": "auto",
  "height": "auto",
}
class PDFViewPresentational extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }



  render() {
    const { intl } = this.props
    const {
      exploreIndex,
      navigateInput,
      document,
      showLoader,
      currentPage,
      isReduxAware

    } = this.props

    const {
      setFlickityRef,
      handlerSelectFlickity,
      handlePdfTag,
      goToPreviousPage,
      handleonKeyUp,
      handleOnChange2,
      goToNextPage,
      isComparingVersion
    } = this.props

    const flickityClasses = classNames({
      "pdf-carousel": !isComparingVersion,

      "compare-versions-components": isComparingVersion,
    })

    const magnifierClasses = classNames({
      "comperVersionMagnifier": isComparingVersion
    })

    const compareVersionsImageWrapper = classNames({
      "compare-versions-image-max-view": isComparingVersion
    })

    return (
      <React.Fragment>

        <Flickity
          className={flickityClasses}
          elementType={'div'}
          options={{
            contain: true,
            pageDots: false,
            cellAlign: 'center',
            draggable: true,
            selectedAttraction: 0.2,
            friction: 0.8,
            fade: true,
            initialIndex: exploreIndex,
            lazyLoad: true,
          }}
          reloadOnUpdate={false}
          fullscreen={true}
          // flickityRef={c => flkty = c}
          flickityRef={setFlickityRef}
        >
          {document.documentPages && document.documentPages.map((d, index) => {
            let itemClassName = currentPage - 1 === index ? 'pdf-carousel-cell is-clicked' : 'pdf-carousel-cell'

            if ((exploreIndex + 2 === document.totalDocumentPages || exploreIndex + 1 === document.totalDocumentPages) &&
              (document.totalDocumentPages - (PAGINATION_SIZE - 1) === index || document.totalDocumentPages - (PAGINATION_SIZE - 2) === index))
              itemClassName = 'pdf-carousel-cell opaque'

            return (
              <div
                id={index}
                key={index}
                className={itemClassName}>
                <div className='slide-wrapper'>
                  <img className='pdf-view-image-cell' style={imgCellPdfViewStyle} onClick={() => handlerSelectFlickity(index)} src={d}
                    alt={document.name.replace(/\s/, '_') + '_' + index} />
                </div>
              </div>
            )
          })}
        </Flickity>

        {!showLoader &&
          <React.Fragment>
            <div className='flex-center'>
              <div className={compareVersionsImageWrapper}>
                <Magnifier
                  style={{ marginTop: '15px' }}
                  className={magnifierClasses}
                  mgShowOverflow={false}
                  alt={document.name.replace(/\s/, '_')}
                  src={document.documentPages[currentPage ? currentPage - 1 : currentPage]}
                />
              </div>
            </div>
            <div className='pdf-view-buttons'>

              {isReduxAware && <div className='container-btn-pdf'>
                <button
                  className="button-comment-tag btn-coment-pdf"
                  onClick={handlePdfTag}
                >
                  <Icon type="tag" style={{ fontSize: '16px', color: '#0095D5' }} />
                  &nbsp;&nbsp;{intl.formatMessage({ id: "comment_page" })} {currentPage}
                </button>
              </div>
              }



              <div style={{ float: 'right', marginTop: '15px', color: '#0096D6', minWidth: '100px' }}>
                <span
                  style={{
                    cursor: 'pointer'
                  }}

                  onClick={goToPreviousPage}>
                  {'<'}
                </span>
                <input type='text'
                  style={{
                    width: '40px',
                    textAlign: 'center',
                  }}

                  className='carousel-input'
                  key={'loaded' + currentPage}
                  value={navigateInput}
                  onKeyUp={handleonKeyUp}
                  onChange={handleOnChange2}
                  required={true}
                />
                <span
                  style={{
                    cursor: 'pointer'
                  }}

                  onClick={goToNextPage}
                >
                  {'>'}
                </span>
                <span>&nbsp; de &nbsp;{document.totalDocumentPages}</span>
              </div>
            </div>
          </React.Fragment>
        }

        {showLoader &&
          <div className='wrapper-clip-loader'>
            < ClipLoader loading={true} size={35} color={"#0096D6"} />
          </div>
        }
      </React.Fragment >
    )
  }
}

export default injectIntl(PDFViewPresentational)
